// Media variants (migration 138): every SmartKraal still or clip and every
// uploaded photo is addressed by its hash, and the API serves it in sizes:
//   /api/v1/media/v/thumb/<sha>     480 px WebP, streamed, cached a week
//   /api/v1/media/v/medium/<sha>    1600 px WebP (stills, photos), redirect
//   /api/v1/media/v/poster/<sha>    the clip's frame at 1 s, 1600 px, streamed
//   /api/v1/media/v/clip720/<sha>   H.264 720p, redirect
//   /api/v1/media/v/orig/<sha>      the original, redirect
// Stored addresses (animals.photo_url, event evidence) are the original's:
// /api/v1/smartkraal/media/<sha> for kraal files, /api/v1/media/v/orig/<sha>
// for uploads. A variant answers 404 until the nightly pass has built it, so
// an <img> that asks for a thumb falls back to the original on error.

const KRAAL_ORIG = /^\/api\/v1\/smartkraal\/media\/([0-9a-f]{64})$/
const VARIANT = /^\/api\/v1\/media\/v\/(thumb|medium|poster|clip720|orig)\/([0-9a-f]{64})$/

/** The hash behind a stored media address, or null for anything else (a legacy
 *  signed URL, a /static path, an external link). */
export function mediaHash(url) {
  if (!url || typeof url !== 'string') return null
  const k = url.match(KRAAL_ORIG)
  if (k) return k[1]
  const v = url.match(VARIANT)
  return v ? v[2] : null
}

/** The address of one size of the file behind ``url``; ``url`` itself when it
 *  is not a hash-addressed media file. */
export function variantUrl(url, variant = 'thumb') {
  const sha = mediaHash(url)
  return sha ? `/api/v1/media/v/${variant}/${sha}` : url
}

/** <img> onError handler: swap a variant that is not built yet for the
 *  original, once. Usage: onError={fallbackToOriginal(originalUrl)}. */
export function fallbackToOriginal(originalUrl) {
  return (e) => {
    const img = e.currentTarget
    if (!originalUrl || img.dataset.fallback === '1') return
    img.dataset.fallback = '1'
    img.src = originalUrl
  }
}
